export default __webpack_public_path__ + "static/media/bg_page_seven.f095a6ff.png";